/**
 * 页面配置管理
 *  英文：https://izt.eastfair.cn/h5-web/#/conference?theme=mianliao&key=hwmap
 */
import dict from './dict'
import ccbn from './ccbn'
import baoli from './baoli'
import mianliao from './mianliao'
import huanbao from './huanbao'

const content = {
  dict: dict,
  ccbn: ccbn,
  baoli,
  mianliao,
  huanbao
}

export default content;